// Tipos para plan y roles
export enum PlanType {
  PRO = 'pro',
  BUSINESS = 'business'
}

export enum PaymentMethod {
  CASH = 'cash',
  TRANSFER = 'transfer',
  CARD = 'card',
  OTHER = 'other'
}

export enum BusinessRole {
  ADMIN = 'admin',
  ADMIN_VENDOR = 'admin_vendor'
}

export type DayKey = 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday';

export interface TimeSlot {
  start: string;
  end: string;
}

export interface Day {
  key: DayKey;
  label: string;
  shortLabel: string;
}

export interface QuickOption {
  id: string;
  label: string;
  days: string[];
}

export interface CommonTimeSlot {
  label: string;
  start: string;
  end: string;
  icon: React.ReactNode;
}

export interface Professional {
  id: string;
  cyclone_id: string | null;
  first_name: string;
  last_name: string;
  isAdmin?: boolean;
  hasWorkingHours: boolean;
  schedule: Record<DayKey, TimeSlot[]>;
}

export enum StepType {
  PAYMENT_METHODS = 0,
  BUSINESS_ROLE = 1,
  TEAM_CREATION = 2,
  WORKING_HOURS = 3,
  FIRST_SERVICE = 4
}

export interface CustomerJourneyState {
  currentStep: StepType;
  plan: PlanType;
  paymentMethods: PaymentMethod[];
  cashInstructions: string;
  transferInstructions: string;
  businessRole: BusinessRole | null;
  professionals: Professional[];
  planProfessionalsCount: number;
  stepsCompleted: Record<StepType, boolean>;
  stepsVisible: Record<StepType, boolean>;
}

export enum ActionType {
  SET_STEP = 'SET_STEP',
  SET_PLAN = 'SET_PLAN',
  TOGGLE_PAYMENT_METHOD = 'TOGGLE_PAYMENT_METHOD',
  SET_CASH_INSTRUCTIONS = 'SET_CASH_INSTRUCTIONS',
  SET_TRANSFER_INSTRUCTIONS = 'SET_TRANSFER_INSTRUCTIONS',
  SET_BUSINESS_ROLE = 'SET_BUSINESS_ROLE',
  ADD_PROFESSIONAL = 'ADD_PROFESSIONAL',
  REMOVE_PROFESSIONAL = 'REMOVE_PROFESSIONAL',
  UPDATE_PROFESSIONAL = 'UPDATE_PROFESSIONAL',
  UPDATE_PROFESSIONALS = 'UPDATE_PROFESSIONALS',
  SET_WORKING_HOURS = 'SET_WORKING_HOURS',
  SET_PLAN_PROFESSIONALS_COUNT = 'SET_PLAN_PROFESSIONALS_COUNT'
}

export type CustomerJourneyAction =
  | { type: ActionType.SET_STEP; payload: StepType }
  | { type: ActionType.SET_PLAN; payload: PlanType }
  | { type: ActionType.TOGGLE_PAYMENT_METHOD; payload: PaymentMethod }
  | { type: ActionType.SET_CASH_INSTRUCTIONS; payload: string }
  | { type: ActionType.SET_TRANSFER_INSTRUCTIONS; payload: string }
  | { type: ActionType.SET_BUSINESS_ROLE; payload: BusinessRole }
  | { type: ActionType.ADD_PROFESSIONAL; payload: Professional }
  | { type: ActionType.REMOVE_PROFESSIONAL; payload: string }
  | { type: ActionType.UPDATE_PROFESSIONAL; payload: Professional }
  | { type: ActionType.UPDATE_PROFESSIONALS; payload: Professional[] }
  | { type: ActionType.SET_WORKING_HOURS; payload: { professionalId: string; hasWorkingHours: boolean } }
  | { type: ActionType.SET_PLAN_PROFESSIONALS_COUNT; payload: number };
